import { render, staticRenderFns } from "./MetatagList.vue?vue&type=template&id=34dc497c&scoped=true&"
import script from "./MetatagList.vue?vue&type=script&lang=js&"
export * from "./MetatagList.vue?vue&type=script&lang=js&"
import style0 from "./MetatagList.vue?vue&type=style&index=0&id=34dc497c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dc497c",
  null
  
)

export default component.exports